import sentryFetch from '@amzn/sentry-fetch';

import { teamRegistryApiEndpoint } from '../config/endpoints';

export interface IRegisterTeamRequest {
  teamName: string;
  authorizerId: string;
  authorizerType: string;
  entityType: string;
}

export interface IRegisterTeamResponse {
  teamId: string;
}

export async function registerTeamApi(requestBody: IRegisterTeamRequest) {
  const response = await sentryFetch(`${teamRegistryApiEndpoint}/register-team`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    sentryOptions: {
      followMidwayStepUp: true,
      followMidwayStepUpOptions: {
        mode: 'modal',
      },
    },
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  const data = await response.json();
  return data as IRegisterTeamResponse;
}
